<template>
	<v-card class="mt-0">
		<v-card-text>
			<MergeUnmatched :item="item" :other="other" :type="type"/>
			<v-divider class="my-12"/>
			<MergeMatched :item="item" :other="other" :type="type"/>
		</v-card-text>
	</v-card>	
</template>

<script>
import _ from 'lodash';
import MergeMatched from '@/components/users/MergeMatched';
import MergeUnmatched from '@/components/users/MergeUnmatched';


export default {
	name: "MergeCard",
	props: {
		item: Object,
		other: Object,
		type: String
	},

	components: {
		MergeMatched,
		MergeUnmatched
	},
	
	watch: {
		async item()
		{
			await this.load();
		},
		async other()
		{
			await this.load();
		},
		async type()
		{
			await this.load();
		}
	},

	async mounted()
	{
		await this.load();
	},

	methods: {

		async load()
		{
			await this.$store.dispatch('entities/load', { type: this.type });
			await this.$store.dispatch('candidates/load', { integrationId: this.item.integrationId, type: this.type, otherSource: this.other.integrationId });
		}

	},


	data: () => ({
		prevType: null
	}),
};
</script>
